var map = {
	"./black/jianting2.png": "40M5",
	"./blue/jianting2.png": "MMEl",
	"./white/jianting2.png": "8u/z"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Dfv5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/jianting2\.png$
// module id = Dfv5
// module chunks = 24